import { render, staticRenderFns } from "./BingoCloud.vue?vue&type=template&id=09622f8b"
import script from "./BingoCloud.vue?vue&type=script&lang=js"
export * from "./BingoCloud.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports